import { RelianceAccount } from '../models/account';
import { IApiService } from '../services/api_service';

export const account = (centralApi: IApiService) => ({
  get: (ani, params = ({} = null)): Promise<RelianceAccount> => {
    return centralApi.get<RelianceAccount>(`/account/${ani}`, {
      params
    });
  }
});
